<mijn-overzicht-template [showHeaderItems]="false">
    <div class="ap-margin-top-12">
        <ap-illustration name="identificeren" height="72px" width="72px"></ap-illustration>
        <h3>{{ getGreeting() }}</h3>
        <div class="ap-width-100-md ap-width-75-xl ap-display-flex ap-flex-column ap-flex-gap-1">
            @if (phoneNumber) {
                <ap-content
                    [key]="'mijn-omgeving.phonenumber-validation.phonenumber-context.number'"
                    [params]="{ phoneNumber: phoneNumber | apPhone }"
                ></ap-content>
                <ng-template [ngTemplateOutlet]="moreInfo"></ng-template>
                <ap-button (onClick)="navigateToContactgegevensBeheren('validate')">
                    {{ 'mijn-omgeving.phonenumber-validation.validate-phonenumber-button-label' | apContent }}
                </ap-button>

                <ap-button (onClick)="navigateToContactgegevensBeheren('change')">
                    {{ 'mijn-omgeving.phonenumber-validation.change-phonenumber-button-label' | apContent }}
                </ap-button>
            } @else {
                <ap-content [key]="'mijn-omgeving.phonenumber-validation.phonenumber-context.nonumber'"></ap-content>
                <ng-template [ngTemplateOutlet]="moreInfo"></ng-template>
                <ap-button (onClick)="navigateToContactgegevensBeheren('new')">
                    {{ 'mijn-omgeving.phonenumber-validation.new-phonenumber-button-label' | apContent }}
                </ap-button>
            }
        </div>
    </div>
</mijn-overzicht-template>

<ng-template #moreInfo>
    <ap-button [compact]="true" [text]="true" class="ap-margin-vertical-2" type="button" (onClick)="openMoreInfoModal()">
        <span class="ap-flex">
            <ap-icon class="ap-margin-right-1" name="help" size="large" />{{ 'mijn-omgeving.phonenumber-validation.more-info' | apContent }}
        </span>
    </ap-button>
</ng-template>
